<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="w-100 text-center text-primary">
                    <i class="fa fa-undo text-primary mr-2"></i>
                    Devoluciones
                </h4>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-card>
                    <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                        Devoluciones
                        <div>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm mr-2"
                                @click="exportBankReturns('csv')">
                                <i class="fa fa-download"></i> CSV
                            </button>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm"
                                @click="exportBankReturns('xlsx')">
                                <i class="fa fa-download"></i> Excel
                            </button>
                            <button
                                :disabled="count<1"
                                class="btn btn-primary btn-sm ml-2"
                                @click="exportBankReturns('pdf')">
                                <i class="fa fa-download"></i> PDF
                            </button>
                        </div>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col cols="4">
                            <vue2-date-picker
                                v-model="search.dates"
                                type="date"
                                range
                                :format="`DD/MM/YYYY`"
                                lang="es"
                                placeholder="Rango de Fechas"
                                :editable="false"
                                :first-day-of-week="1"
                                :shortcuts="datepicker.shortcuts"
                                class="w-100 date-picker-w-100 date-picker-custom-border"></vue2-date-picker>
                        </b-col>
                        <b-col cols="2" offset="6">
                            <div class="d-flex flex-row-reverse">
                                <button
                                    class="btn btn-pill btn-primary px-4"
                                    @click="searchBankReturns()">
                                    Filtrar
                                </button>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <v-server-table
                                ref="bankReturnsTable"
                                class="dataTable"
                                md="12"
                                lg="12"
                                sm="12"
                                :columns="columns"
                                :options="options"
                                :theme="theme"
                                 @sorted="tableSorted">
                                <template slot="beforeBody">
                                    <tr v-if="loading">
                                        <td class="text-center loading" colspan="5"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                                    </tr>
                                </template>
                                <template slot="select" slot-scope="props">
                                    <input type="checkbox" class="pt-1" :value="props.row.uuid" v-model="selectedConsignmentsIds">
                                </template>
                                <template slot="uuid" slot-scope="props">
                                    <router-link
                                        v-b-tooltip.hover.top
                                        title="Ver"
                                        class="btn p-0"
                                        :to="{ name: 'bankReturnOverview', params: { uuid: props.row.uuid  }}">
                                        <i class="fa fa-eye"></i>
                                    </router-link>
                                    <button
                                        v-if=""
                                        v-b-tooltip.hover.top
                                        title="Imprimir Recibos"
                                        class="btn pb-1 pl-1 pr-0"
                                        @click="openPrintReceiptsModal(props.row.receipts)">
                                        <i class="fa fa-print"></i>
                                    </button>
                                    <button
                                        v-if=""
                                        v-b-tooltip.hover.top
                                        title="Borrar Devolución"
                                        class="btn pb-1 pl-1"
                                        @click="deleteBankReturn(props.row.uuid)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </template>



                                <template slot="createdAt" slot-scope="props">
                                    {{props.row.createdAt | dateFormat('DD/MM/YYYY HH:mm')}}
                                </template>

                                <template slot="headquarters" slot-scope="props">
                                    <span v-for="headquarter in props.row.headquarters">{{headquarter}}</span>
                                </template>

                                <template slot="amount" slot-scope="props">
                                    {{props.row.amount}}€
                                </template>

                                <template slot="documentHeaderDate" slot-scope="props">
                                    {{props.row.documentHeaderDate | dateFormat('DD/MM/YYYY HH:mm')}}
                                </template>

                                <template slot="createdBy" slot-scope="props">
                                    {{props.row.createdBy.fullName}}
                                </template>

                                <template slot="afterFilter">
                                    <b-row class="mb-3">
                                        <b-col cols="6">
                                            <consignment-action-selector
                                                v-model="actionSelector"
                                                :allowEmpty="true"
                                                :bankReturn="true"
                                                :searchData="searchData"
                                                :selectedConsignmentsIds="selectedConsignmentsIds"
                                                :allowConsignmentActions="allowConsignmentActions"
                                                :consignmentIssuePermission="!!mixinCheckPermission('CONSIGNMENT_ISSUE')"
                                                :consignmentPostPermission="!!mixinCheckPermission('CONSIGNMENT_POST')"
                                                :consignmentDeletePermission="!!mixinCheckPermission('CONSIGNMENT_DELETE')"
                                                @selected-action="selectedAction"></consignment-action-selector>
                                        </b-col>
                                        <b-col>
                                            <div v-if="!!selectedConsignmentsIds.length" class="selected-consignments"><i class="fa fa-check" aria-hidden="true"></i>Remesas seleccionadas: <span class="number">{{ selectedConsignmentsIds.length }}</span></div>
                                        </b-col>
                                    </b-row>
                                </template>
                            </v-server-table>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-modal
            ref="uploadSepaFileModal"
            hide-footer
            size="md"
            title="Subir SEPA Devolución"
            class="text-center"
            @hidden="uploadSepaFileModalClosed()">
            <b-row>
                <b-col cols="12">
                    <b-form-file
                        ref="sepaFileInput"
                        v-model="sepaFile"
                        placeholder="Seleccionar">
                    </b-form-file>
                </b-col>
            </b-row>
            <b-row class="border-top mt-4 pt-3 px-3 flex-row-reverse">
                <button
                    type="submit"
                    class="btn btn-brand btn-primary col-auto btn-lg float-right"
                    sm="12"
                    :disabled="!sepaFile"
                    @click="uploadSepaFile()">
                    Subir
                </button>
            </b-row>
        </b-modal>

        <b-modal
            ref="printReceiptsModal"
            hide-footer
            size="sm"
            title="Imprimir Recibos"
            class="text-center"
            @hidden="printReceiptsModalClosed">
            <b-row>
                <b-col class="text-left">
                    <b-form-checkbox
                        type="checkbox"
                        stacked
                        v-model="receiptsToPrint.specifyExpeditionDate"
                        name="hide">Especificar fecha de expedición
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row v-if="!!receiptsToPrint.specifyExpeditionDate" class="mt-3">
                <b-col>
                    <v-date-picker
                        class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                        v-model="receiptsToPrint.expeditionDate">
                    </v-date-picker>
                </b-col>
            </b-row>

            <b-row v-if="!!receiptsToPrint.uuids" class="mt-3">
                <b-col class="d-flex flex-row-reverse">
                    <button
                        class="btn btn-brand btn-primary btn-lg"
                        :disabled="!!receiptsToPrint.specifyExpeditionDate && !receiptsToPrint.expeditionDate"
                        @click="printReceipts(receiptsToPrint.uuids, receiptsToPrint.expeditionDate)">
                        Imprimir
                    </button>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {ServerTable, Event} from 'vue-tables-2';
    import form from '@/helpers/form';
    import {downloadJsonAsPdf} from '@/helpers/js-pdf';
    import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
    import Vue2DatePicker from 'vue2-datepicker';
    import {getBankReturns, deleteBankReturn, getBankReturnSeatsFiles} from '@/api/bank-return-api';
    import {updateReceiptsFromSepa, printReceipts} from '@/api/receipt-api';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import consignmentActionSelector from '@/components/consignments/ConsignmentActionSelector';

    import Spinner from 'vue-simple-spinner';
    import JSZip from 'jszip'
    import { saveAs } from 'file-saver';
    import { v4 as uuidv4 } from 'uuid';
    setupCalendar({
        firstDayOfWeek: 2,// Monday
    });
    Vue.use(ServerTable);

    export default {
        name: "ListBankReturns",
        components: {
            Vue2DatePicker,
            consignmentActionSelector,
            'v-date-picker': DatePicker,
            Spinner
        },
        data() {
            return {
                topMenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Subir SEPA Devolución',
                        emit: 'uploadSepaFile',
                        brand: 'fa fa-file',
                        permissions: ['RECEIPT_EDIT']
                    }
                ],
                columns: ['select', 'uuid','documentHeaderId', 'documentHeaderDate', 'headquarters', 'amount', 'createdBy', 'createdAt'],
                loading: true,
                options: {
                    headings: {
                        select: {
                            text: ''
                        },
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        uuid_detalle: '',
                        documentHeaderId: 'Identificador Documento',
                        documentHeaderDate: 'Fecha Documento',
                        headquarters: 'Sedes',
                        amount: 'Importe Total Devuelto',
                        createdBy: 'Usuario',
                        createdAt: 'Fecha Subida'
                    },
                    columnsClasses: {
                        uuid: "fit normal-query"
                    },
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    sortable: ['documentHeaderId', 'documentHeaderDate', 'headquarters', 'amount', 'createdBy', 'createdAt'],
                    filterable: false,
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    },
                    requestFunction: (data) => {
                        if (this.$store.getters.getFilters[0] !== null) {
                          this.search.dates = this.$store.getters.getFilters[0];
                        }
                        this.search.page = data.page;
                        this.search.itemsPerPage = data.limit;
                        return getBankReturns(this.searchData);
                    },
                    responseAdapter: (data) => {
                        return {
                            data: data.bankReturns,
                            count: data.count
                        }
                    },
                },
                theme: 'bootstrap4',
                search: {
                    page: 1,
                    itemsPerPage: 10,
                    dates: null
                },
                 orderBy: {
                    column: null,
                    ascending: null
                },
                count: 0,
                datepicker: {
                    shortcuts: [
                        {
                            text: 'Hoy',
                            onClick: () => {
                                let dateStart = new Date();
                                dateStart.setHours(0, 0, 0);
                                let dateEnd = new Date();
                                dateEnd.setHours(23, 59, 59);
                                this.search.dates = [dateStart, dateEnd]
                            }
                        },
                        {
                            text: 'Últimos 7 días',
                            onClick: () => {
                                let days = 7;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.search.dates = [last, today]
                            }
                        },
                        {
                            text: 'Últimos 30 días',
                            onClick: () => {
                                let days = 30;
                                let today = new Date();
                                today.setHours(23, 59, 59);
                                let last = new Date(today.getTime() - (days * 24 * 60 * 60 * 1000));
                                last.setHours(0, 0, 0);
                                this.search.dates = [last, today]
                            }
                        }
                    ]
                },
                actionSelector : null,
                selectedConsignmentsIds: [],
                selectedConsignments: {},
                allowConsignmentActions: [],

                sepaFile: null,
                receiptsToPrint: {
                    uuids: null,
                    specifyExpeditionDate: false,
                    expeditionDate: null
                }
            }
        },
        created() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topMenu);

            Event.$on('vue-tables.loading', (data) => {
                this.$_loadingMixin_showLoading();
                this.count = 0;
                this.loading = true;
                if (!!this.$refs.bankReturnsTable && !!this.$refs.bankReturnsTable.data) {
                    //this.$refs.bankReturnsTable.data = [];
                    if (!!document.querySelector('.VueTables__no-results')) {
                        document.querySelector('.VueTables__no-results').style.display = 'none';
                    }
                }
            });
            Event.$on('vue-tables.loaded', (data) => {
                if (!!data && !!data.count) {
                    this.count = data.count;
                    this.loadedConsignments = data.bankReturns;
                }
                this.$_loadingMixin_hideLoading();
                this.loading = false;
                if (!!document.querySelector('.VueTables__no-results')) {
                    document.querySelector('.VueTables__no-results').style.display = 'table-row';
                }
            });
            this.$eventHub.$on('uploadSepaFile', obj => {
                this.$refs.uploadSepaFileModal.show();
            });
        },
        computed: {
            searchData() {
                let data = {
                    page: this.search.page,
                    itemsPerPage: this.search.itemsPerPage,
                };

                if (
                    Array.isArray(this.search.dates)
                    && this.search.dates.length === 2
                    && this.search.dates[0] != null
                    && this.search.dates[1] != null
                ) {
                    data['startDate'] = this.search.dates[0].toISOString();
                    data['endDate'] = this.search.dates[1].toISOString();
                }
                if (!!this.orderBy.column) {
                    data['orderColumn'] = this.orderBy.column;
                }
                data['orderAscending'] = this.orderBy.ascending ? 1 : 0;
                return data;
            }
        },
        methods: {
            searchBankReturns() {
                let filterData = [];
                filterData.push(this.search.dates);
                this.$store.commit('SET_FILTERS_LIST', filterData);
                this.$refs.bankReturnsTable.refresh();
            },
            selectedAction(action) {
                switch (action) {
                    case 'Seleccionar devoluciones visibles':
                        this.selectVisibleConsignments();
                        break;
                    case 'Deseleccionar todas':
                        this.deselectAllConsignments();
                        break;
                    case 'Descargar Asientos':
                        this.getSeatsFiles(this.selectedConsignmentsIds);
                        break;
                }
            },
            selectVisibleConsignments() {
                this.selectedConsignmentsIds = []
                if (!this.isAllConsignmentsSelected) {
                    for (let i in this.loadedConsignments) {
                        this.selectedConsignmentsIds.push(this.loadedConsignments[i].uuid);
                    }
                }
            },
            deselectAllConsignments() {
                this.selectedConsignmentsIds = [];
            },
            async getSeatsFiles(uuids) {
                this.$_loadingMixin_showLoading();
                const zipFile = new JSZip();

                for await (let uuid of uuids) {
                  let consignment = this.getConsignmentFromArray(uuid);
                  const zipFileTmp = new JSZip();
                  const fileArray = await this.getSeatsFile(consignment);
                  const file = new Blob([fileArray], {type: 'application/zip'});
                  const zip = await zipFileTmp.loadAsync(file)
                  for (let f of Object.keys(zip.files)) {
                    const zfile = await zip.file(zip.files[f].name).async('string')
                    zipFile.file(`${zip.files[f].name}`, zfile )
                  }
                }
                const blob = await zipFile.generateAsync({type: 'blob'})
                saveAs(blob, `${uuidv4()}.zip`)
                this.deselectAllConsignments();
                this.$_loadingMixin_hideLoading();
            },
            async getSeatsFile(consignment) {
                try {
                    this.$_loadingMixin_showLoading();
                    const dataStream = await getBankReturnSeatsFiles(consignment.uuid)
                    this.$_loadingMixin_hideLoading();
                    return dataStream;
                } catch (error) {
                    this.$_loadingMixin_hideLoading();
                    console.log(error)
                    this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar los asientos");
                }

            },
            getConsignmentFromArray(uuid) {
                let index = this.loadedConsignments.findIndex(item => item.uuid == uuid);
                return this.loadedConsignments[index];
            },
            async exportBankReturns(format) {
                if (this.count > 0) {
                    this.$_loadingMixin_showLoading();

                    // let parameters = Object.assign({}, this.searchData);
                    // parameters.page = 1;
                    // parameters.itemsPerPage = this.count;
                    //
                    // let response = await getBankReturns(parameters);
                    let response = await getBankReturns(this.searchData);

                    let rows = response.bankReturns.map((bankReturn) => {
                        return this.normalizeBankReturn(bankReturn);
                    });

                    if (format === 'csv') {
                        downloadJsonAsCsv(rows);
                    } else if (format === 'xlsx') {
                        downloadJsonAsXlsx(rows);
                    } else if(format === 'pdf') {
                        downloadJsonAsPdf(rows);
                    }

                    this.$_loadingMixin_hideLoading();
                }
            },
            normalizeBankReturn(bankReturn) {
                return {
                    'Identificador Documento': bankReturn.documentHeaderId,
                    'Fecha Documento': bankReturn.documentHeaderDate.toLocaleDateString(),
                    'Sedes': bankReturn.headquarters,
                    'Importe Total Devuelto': bankReturn.amount,
                    'Usuario': bankReturn.createdBy.uuid,
                    'Fecha Subida': bankReturn.createdAt.toLocaleDateString()
                };
            },
            tableSorted(data) {
                this.orderBy.column = data.column;
                this.orderBy.ascending = data.ascending;
            },
            uploadSepaFileModalClosed() {
                this.$refs['sepaFileInput'].reset()
            },
            async uploadSepaFile() {
                this.$_loadingMixin_showLoading();
                await updateReceiptsFromSepa(this.sepaFile)
                    .then(() => {
                        this.$_notificationMixin_success('Operación completada', 'Se ha subido el documento');
                        this.$refs.uploadSepaFileModal.hide();
                        this.searchBankReturns();
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Error en la operación', 'No se ha subido el documento');
                    });
                this.$_loadingMixin_hideLoading();
            },
            async printReceipts(uuids, expeditionDate) {
                this.$_loadingMixin_showLoading();
                await printReceipts(uuids, expeditionDate)
                    .then((dataStream) => {
                        const file = new Blob([dataStream], {type: "application/pdf"});
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    })
                    .catch(() => {
                        this.$_notificationMixin_error("Se ha producido un error", "No hemos podido recuperar la previsualización del documento");
                    });
                this.$_loadingMixin_hideLoading();
            },
            async deleteBankReturn(bankReturnId) {
                swal({
                    title: '¿Estás seguro de eliminar la devolución seleccionada?',
                    text: "Esta operación no se podrá revertir",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Sí, elimínala!'
                }).then((result) => {
                    if (result.value) {

                        this.$_loadingMixin_showLoading();

                        deleteBankReturn(bankReturnId)
                            .then((data) => {
                                this.searchBankReturns();
                            })
                            .catch((error) => {
                                this.$_notificationMixin_error('Error en la operación', 'No se ha borrado la devolución');
                            });

                        this.$_loadingMixin_hideLoading();

                    }
                });
            },
            openPrintReceiptsModal(uuids) {
                this.receiptsToPrint.uuids = uuids;
                this.$refs.printReceiptsModal.show();
            },
            printReceiptsModalClosed() {
                this.receiptsToPrint.uuid = null;
                this.receiptsToPrint.specifyExpeditionDate = false;
                this.receiptsToPrint.expeditionDate = null;
            }
        },        watch: {
            selectedConsignmentsIds: function() {
                this.allowConsignmentActions['download_seats'] = true;

                for (let i in this.selectedConsignmentsIds) {
                    let consignment = this.getConsignmentFromArray(this.selectedConsignmentsIds[i]);
                    switch (consignment.status) {
                        case 'CREATED':
                            this.allowConsignmentActions['post'] = false;
                            this.allowConsignmentActions['download_sepa'] = false;
                            this.allowConsignmentActions['download_seats'] = false;
                            break;
                        case 'ISSUED':
                            this.allowConsignmentActions['download_seats'] = false;
                            break;
                        case 'POSTED':
                            this.allowConsignmentActions['issue'] = false;
                            this.allowConsignmentActions['post'] = false;
                            this.allowConsignmentActions['delete'] = false;
                            if (!consignment.seatsDiary || !consignment.seatsSubAccounts) {
                                this.allowConsignmentActions['download_seats'] = false;
                            }
                            break;
                    }
                }
            },
            loadedConsignments: function() {
                this.deselectAllConsignments();
            }

        }
    }
</script>

<style lang="scss">
    .VueTables__no-results {
        display: none;
    }

    .VueTables .VueTables__search {
        width: calc(66.6% + 20px);
    }

    .VueTables .VueTables__search .row {
        width: 100%;
    }
</style>
